import { configureStore } from '@reduxjs/toolkit';
import rootReducer from './rootReducer';
import handleUnauthorized from '../service-api/errorHandler';
import { API } from '../service-api';

const store = configureStore({
  reducer: {
    [API.reducerPath]: API.reducer,
    ...rootReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware()
    .concat(API.middleware)
    .concat(handleUnauthorized),
});

export default store;

// import { configureStore } from '@reduxjs/toolkit';
// import rootReducer from './rootReducer';

// const store = configureStore({
//   reducer: rootReducer,
// });

// export default store;
